import { singupInit } from "./singup"

document.addEventListener("DOMContentLoaded", function() {
  console.log("shcool init2")
  singupInit()
})
